module.exports = __webpack_public_path__ + "static/img/shouhou.f25ac7a2.png";